<h5 class="m-3">
    {{ 'variable-alarms_create-alarm-help-text' | translate }}
</h5>
@if (view$ | async; as view) {
    <div class="container-fluid pb-3">
        @if (view.loading) {
            <app-load></app-load>
        } @else {
            <form
                [formGroup]="formGroup"
                class="slim-card-container"
                (submit)="
                    submit(view.value.buildingNo, view.value.usageUnitWithTranslation, formGroup)
                ">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card mb-3">
                            <div class="card-body">
                                <app-input-text-group
                                    [label]="'monitoring_agentName' | translate"
                                    formControlName="alarmName"></app-input-text-group>
                                <app-input-select-option-group
                                    formControlName="usageAndUnit"
                                    [label]="'monitoring_usageAndUnits' | translate"
                                    [data]="usageAndUnitMap"
                                    sortOrder="asc" />
                                @if (formGroup.getRawValue().usageAndUnit != null) {
                                    <div class="d-flex justify-content-end mt-3">
                                        <button
                                            class="btn btn-outline-primary"
                                            type="button"
                                            (click)="
                                                selectMeters(formGroup, view.value.metersForAgents)
                                            ">
                                            {{ 'common_SELECT_METERS' | translate }}
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="mb-3">
                                    <div class="form-label">
                                        {{
                                            'variable-alarms_the-alarm-will-investigate' | translate
                                        }}
                                    </div>
                                    {{ formGroup.getRawValue().usageAndUnit }}
                                </div>
                                <div class="mb-3">
                                    <div class="form-label required">
                                        {{
                                            'variable-alarms_Number-of-selected-meters' | translate
                                        }}
                                    </div>
                                    {{ formGroup.getRawValue().meterIds.length }}
                                    <app-control-messages
                                        [control]="
                                            formGroup.controls.meterIds
                                        "></app-control-messages>
                                </div>
                                <div class="mb-3">
                                    <div class="form-label required">
                                        {{
                                            'variable-alarms_I-want-to-investigate-if-level-is'
                                                | translate
                                        }}
                                    </div>
                                    <div class="mb-3">
                                        <div class="form-check">
                                            <input
                                                type="radio"
                                                class="form-check-input"
                                                id="deviationType-1"
                                                value="I"
                                                formControlName="deviationType" />
                                            <label class="form-check-label" for="deviationType-1">
                                                {{ 'variable-alarms_above' | translate }}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                type="radio"
                                                class="form-check-input"
                                                id="deviationType-2"
                                                value="D"
                                                formControlName="deviationType" />
                                            <label class="form-check-label" for="deviationType-2">
                                                {{ 'variable-alarms_under' | translate }}
                                            </label>
                                        </div>
                                        <app-control-messages
                                            [control]="
                                                formGroup.controls.deviationType
                                            "></app-control-messages>
                                    </div>

                                    <app-input-number-group
                                        class="col-9"
                                        formControlName="deviationValue"
                                        [descriptor]="
                                            unitFromUsageUnit.get(
                                                formGroup.getRawValue().usageAndUnit ?? ''
                                            )
                                        "></app-input-number-group>
                                </div>

                                <app-input-number-group
                                    [label]="
                                        'variable-alarms_notify-me-only-if-it-occurs-more-than'
                                            | translate
                                    "
                                    class="col-9"
                                    formControlName="minimumDeviationPeriod"
                                    [descriptor]="
                                        'titles_frequency-hours'
                                            | translate: 'online' : 'monitoringAlarms'
                                    "></app-input-number-group>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="mb-3">
                                    <app-checkbox-group
                                        formControlName="notificationBreaks"
                                        [label]="
                                            'variable-alarms_notificationBreaks' | translate
                                        "></app-checkbox-group>
                                </div>
                                @if (formGroup.value.notificationBreaks) {
                                    <app-input-number-group
                                        [label]="
                                            'variable-alarms_notify-me-instantly-and-thereafter-only-every'
                                                | translate
                                        "
                                        class="col-9"
                                        formControlName="throttle"
                                        [descriptor]="
                                            'titles_frequency-hours'
                                                | translate: 'online' : 'monitoringAlarms'
                                        "></app-input-number-group>
                                }

                                <div>
                                    <div class="mb-3">
                                        <app-checkbox-group
                                            formControlName="notifyInSpecificTimePeriods"
                                            [label]="
                                                'variable-alarms_notify_in_specific_time_periods'
                                                    | translate
                                            "></app-checkbox-group>
                                    </div>
                                    @if (formGroup.value.notifyInSpecificTimePeriods) {
                                        <div class="form-label required">
                                            {{
                                                'variable-alarms_Notify-me-only-if-it-occurs-within-this-time-period'
                                                    | translate
                                            }}
                                        </div>
                                        <div class="d-flex">
                                            <div class="me-3">
                                                <app-input-select-option-group
                                                    [sortOrder]="'keys'"
                                                    [label]="
                                                        'titles_from'
                                                            | translate
                                                                : 'online'
                                                                : 'monitoringAlarms'
                                                    "
                                                    formControlName="startTime"
                                                    [data]="
                                                        periodicallyTimes
                                                    "></app-input-select-option-group>
                                            </div>
                                            <div>
                                                <app-input-select-option-group
                                                    [sortOrder]="'keys'"
                                                    [label]="
                                                        'titles_to'
                                                            | translate
                                                                : 'online'
                                                                : 'monitoringAlarms'
                                                    "
                                                    formControlName="endTime"
                                                    [data]="
                                                        periodicallyTimes
                                                    "></app-input-select-option-group>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <app-input-email-list
                                    [label]="'monitoring_e-mails' | translate"
                                    formControlName="recipients"></app-input-email-list>
                            </div>
                        </div>
                    </div>
                    <div class="button-group text-end">
                        <a class="btn btn-outline-primary" [routerLink]="['../..']">
                            {{ 'common_cancel_button' | translate }}
                        </a>
                        @if ((variableAlarmToEditSubject | async) === null) {
                            <button
                                class="btn btn-outline-primary ms-1"
                                type="button"
                                (click)="resetValues(formGroup)">
                                {{ 'actions_reset_values' | translate: 'online' : 'common' }}
                            </button>
                        }
                        <button class="btn btn-primary ms-1" type="submit">
                            {{ 'actions_save' | translate: 'online' : 'common' }}
                        </button>
                    </div>
                </div>
            </form>
        }
    </div>
}
